<template>
  <div class="custom-language-select">
    <button
      class="language-button"
      @click="
        isLanguageSelectOpen = !isLanguageSelectOpen;
        track('Language select');
      "
      tabindex="0"
    >
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
        <path class="st0" d="M23.8,44.9l9.5-25.1h4.2l9.8,25.1h-4.5l-2.2-6.7h-10l-2.4,6.7H23.8z M31.7,34.6h7.4l-3.7-10.1h-0.1L31.7,34.6z M7.3,38.6l-2.9-2.8L15.1,25c-1.4-1.5-2.6-3-3.6-4.6s-1.9-3.2-2.7-4.8h4.6c0.6,1.1,1.2,2.2,1.9,3.2s1.5,2.1,2.4,3.2 c1.6-1.6,2.9-3.3,4-5.1c1.1-1.8,2-3.6,2.7-5.5H1V7.2h14.6V3.1h4.2v4.2h14.6v4.2h-5.9c-0.8,2.4-1.8,4.8-3.1,7.1s-2.9,4.5-4.7,6.6 l5.2,5.2l-1.5,4.2l-6.7-6.4L7.3,38.6z"/>
      </svg> 
      <span>{{ this.lang }}</span> 
      <i class="fas fa-caret-down"></i>
    </button>

    <transition name="fade">
      <div class="language-select" v-show="isLanguageSelectOpen">
        <router-link
          to="/de"
          class="language-option"
          :class="{ active: this.lang === 'de' }"
          @click="
            languageAction('de');
            isLanguageSelectOpen = false;
            track('Language - German');
          "
        >
          Deutsch
          <i class="far fa-check-circle" v-if="this.lang === 'de'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

        <router-link
          to="/"
          class="language-option"
          :class="{ active: this.lang === 'en' }"
          @click="
            languageAction('en');
            isLanguageSelectOpen = false;
            track('Language - English');
          "
        >
          English
          <i class="far fa-check-circle" v-if="this.lang === 'en'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

        <router-link
          to="/es"
          class="language-option"
          :class="{ active: this.lang === 'es' }"
          @click="
            languageAction('es');
            isLanguageSelectOpen = false;
            track('Language - Spanish');
          "
        >
          Español
          <i class="far fa-check-circle" v-if="this.lang === 'es'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

        <router-link
          to="/fr"
          class="language-option"
          :class="{ active: this.lang === 'fr' }"
          @click="
            languageAction('fr');
            isLanguageSelectOpen = false;
            track('Language - French');
          "
        >
          Français
          <i class="far fa-check-circle" v-if="this.lang === 'fr'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

        <router-link
          to="/it"
          class="language-option"
          :class="{ active: this.lang === 'it' }"
          @click="
            languageAction('it');
            isLanguageSelectOpen = false;
            track('Language - Italian');
          "
        >
          Italiano
          <i class="far fa-check-circle" v-if="this.lang === 'it'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

        <router-link
          to="/jp"
          class="language-option"
          :class="{ active: this.lang === 'jp' }"
          @click="
            languageAction('jp');
            isLanguageSelectOpen = false;
            track('Language - Japanese');
          "
        >
          日本
          <i class="far fa-check-circle" v-if="this.lang === 'jp'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

        <router-link
          to="/nl"
          class="language-option"
          :class="{ active: this.lang === 'nl' }"
          @click="
            languageAction('nl');
            isLanguageSelectOpen = false;
            track('Language - Dutch');
          "
        >
          Nederlands
          <i class="far fa-check-circle" v-if="this.lang === 'nl'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

        <router-link
          to="/pt"
          class="language-option"
          :class="{ active: this.lang === 'pt' }"
          @click="
            languageAction('pt');
            isLanguageSelectOpen = false;
            track('Language - Portuguese');
          "
        >
          Portuguese
          <i class="far fa-check-circle" v-if="this.lang === 'pt'"></i>
          <i class="far fa-circle" v-else></i>
        </router-link>

      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    lang: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLanguageSelectOpen: false,
    };
  },
  methods: {
    ...mapActions(["languageAction"]),
    track(what) {
      this.$gtag.event("Click events", {
        event_label: what,
      });
    },
  },
  created: function () {
    let self = this;

    window.addEventListener("click", function (e) {
      //close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.isLanguageSelectOpen = false;
      }
    });
  },
};
</script>

<style>
</style>